module.exports = __webpack_public_path__ + "img/8.fc827547.png";